import { render } from "./ComplainChat.vue?vue&type=template&id=c3898ae2"
import script from "./ComplainChat.vue?vue&type=script&lang=js"
export * from "./ComplainChat.vue?vue&type=script&lang=js"

import "./ComplainChat.vue?vue&type=style&index=0&id=c3898ae2&lang=css"

import exportComponent from "D:\\CAS Project\\ESM Web App\\master ESM-WEB\\esm-web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__